/** CJ B5 5.0.4. No third-party slider, canvas processing or altered result photos.
 * Full side-by-side originals are the no-JS/error fallback. Only loaded pairs
 * become a comparison; all event listeners are released on editor replacement.
 */
class CJImageCompare extends HTMLElement {
  #abort;
  connectedCallback() {
    this.#abort?.abort(); this.#abort = new AbortController();
    const signal = this.#abort.signal;
    const images = [...this.querySelectorAll('.cj-compare-image')];
    const range = this.querySelector('.cj-compare-range');
    const tools = this.querySelector('.cj-compare-tools');
    const toggle = this.querySelector('.cj-compare-toggle');
    const handle = this.querySelector('.cj-compare-handle');
    const update = () => {
      const value = Math.min(100, Math.max(0, Number(range?.value) || 0));
      this.style.setProperty('--cj-compare-position', `${value}%`);
      range?.setAttribute('aria-valuetext', `${value}% antes, ${100 - value}% después`);
    };
    const setView = (paired) => {
      this.dataset.view = paired ? 'paired' : 'slider';
      if (range) range.hidden = paired;
      if (handle) handle.hidden = paired;
      if (toggle) { toggle.setAttribute('aria-pressed', String(paired)); toggle.textContent = paired ? 'Usar comparador' : 'Ver fotos completas'; }
      const help = this.querySelector('.cj-compare-help');
      if (help) help.textContent = paired ? 'Antes y después, sin recortes' : 'Desliza para comparar';
    };
    const checkImages = () => {
      let failed = false;
      images.forEach((image) => {
        const error = image.complete && image.naturalWidth === 0;
        const figure = image.closest('.cj-compare-photo');
        figure?.classList.toggle('cj-compare-photo--error', error);
        const original = figure?.querySelector('.cj-compare-original');
        if (original) original.hidden = !error;
        failed ||= error;
      });
      const ready = images.length === 2 && !failed && images.every(image => image.complete && image.naturalWidth > 0);
      if (ready) {
        if (this.dataset.ready !== 'true') {
          this.dataset.ready = 'true';
          if (tools) tools.hidden = false;
          setView(false); update();
        }
      } else {
        delete this.dataset.ready; setView(true);
        if (tools) tools.hidden = true;
      }
    };
    images.forEach(image => {
      image.addEventListener('load', checkImages, { signal });
      image.addEventListener('error', checkImages, { signal });
    });
    range?.addEventListener('input', update, { signal });
    toggle?.addEventListener('click', () => setView(this.dataset.view !== 'paired'), { signal });
    checkImages();
  }
  disconnectedCallback() { this.#abort?.abort(); }
}
if (!customElements.get('cj-image-compare')) customElements.define('cj-image-compare', CJImageCompare);
